import { useSyncExternalStore } from "react";

export type CookieConsent = "accepted" | "rejected" | null;
const KEY = "cookie_consent";
const CHANGE_EVENT = "cookie-consent-change";
const OPEN_EVENT = "cookie-preferences-open";
let volatileConsent: CookieConsent | undefined;

export function getCookieConsent(): CookieConsent {
  if (typeof window === "undefined") return null;
  if (volatileConsent !== undefined) return volatileConsent;
  try {
    const value = window.localStorage.getItem(KEY);
    return value === "accepted" || value === "rejected" ? value : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value: Exclude<CookieConsent, null>) {
  volatileConsent = value;
  try {
    window.localStorage.setItem(KEY, value);
    volatileConsent = undefined;
  } catch {
    // Respect the choice for this visit even when browser storage is blocked.
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

function subscribe(onChange: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== KEY && event.key !== null) return;
    volatileConsent = undefined;
    onChange();
  };
  window.addEventListener(CHANGE_EVENT, onChange);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange);
    window.removeEventListener("storage", onStorage);
  };
}

export function useCookieConsent() {
  return useSyncExternalStore(subscribe, getCookieConsent, () => null);
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}

export function subscribeCookiePreferences(onOpen: () => void) {
  window.addEventListener(OPEN_EVENT, onOpen);
  return () => window.removeEventListener(OPEN_EVENT, onOpen);
}
